import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AdminApp } from './App';
import { detectAdminLang } from './i18n';
import { createAdminRouter } from './router';
import './styles.css';
import '@nexora/ui/genesis.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    <AdminApp router={createAdminRouter()} initialLang={detectAdminLang()} />
  </StrictMode>,
);

import './admin-design.css';
